import {AutocompleteAddress} from "./autocompleteaddress";

export enum Role {
    amministratore = 'amministratore',
    manutentore = 'manutentore',
    backoffice = 'backoffice',
    esco ="esco",
    terzo_responsabile="terzo_responsabile"
}

export class User {
    id?: number;
    idStripe?: string;
    email?: string;
    name?: string;
    lastname?: string;
    fiscalCode?: string;
    vat?: string;
    businessAddress?: AutocompleteAddress;
    website?: string;
    phone?: string;
    role?: Role;
    pec?: string;
    sdi?: string;
    status?: number;
    password?: string;
    createdAt?: Date;
    updatedAt?: Date;
    ragioneSociale?: string;
    tipoAttivita?: string;
    referral?: string;

    //
    iban?: string
    birthDate?: string

    // static methods
    public static displayRole(user: User): string | null {
        switch (user.role) {
            case Role.amministratore:
                return 'Amministratore';
            case Role.manutentore:
                return 'Manutentore';
            case Role.backoffice:
                return 'Backoffice';
            case Role.terzo_responsabile:
                return "Terzo responsabile"
            case Role.esco:
                return "Esco"
            default:
                return null;
        }
    }

    public static displayRoleByRole(role: Role): string | null {
        switch (role) {
            case Role.amministratore:
                return 'Amministratore';
            case Role.manutentore:
                return 'Manutentore';
            case Role.backoffice:
                return 'Backoffice';
            case Role.terzo_responsabile:
                return "Terzo responsabile"
            case Role.esco:
                return "Esco"
            default:
                return null;
        }
    }


    public static displayName(user: User): string {
        return `${user.name} ${user.lastname}`;
    }
}

